import { httpClient } from "./httpClient";
import { AnnouncementModel } from "./types/announcements";

type AnnouncementResponse = {
  announcements: AnnouncementModel[];
};

export async function getAllAnnouncements(): Promise<AnnouncementResponse> {
  try {
    const { data } = await httpClient.get<AnnouncementResponse>(
      `/api/v1/announcements`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getAllActiveAnnouncements(): Promise<
  AnnouncementResponse
> {
  try {
    const { data } = await httpClient.get<AnnouncementResponse>(
      `/api/v1/announcements/active`
    );
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getAnnouncementById(
  id: number
): Promise<AnnouncementModel> {
  try {
    const { data } = await httpClient.get<AnnouncementModel>(
      `/api/v1/announcements/${id}`
    );

    return data;
  } catch (error) {
    throw error;
  }
}
